import { AstraParagraph, getOnlyDate, Spinner } from '~/astra'
import { useStore } from '~/store/store'
import { useActivePractitioners, useActiveRecurringAssignments } from '~/storm'

import { PractitionersPreview } from '../PractitionersPreview/PractitionersPreview'
import { RecurringAssignmentToggleList } from '../RecurringAssignmentToggleList'
import { useApplyPreviewData } from './useApplyPreviewData'
import { useApplyRecurringAssignmentsMutation } from './useApplyRecurringAssignmentsMutation'
import { useApplyRecurringAssignmentsQuery } from './useApplyRecurringAssignmentsQuery'

const Loader = () => (
    <div className="flex flex-col items-center gap-8">
        <Spinner size="lg" />
        <AstraParagraph variant="body" weight="medium">
            Laster forhåndsvisning...
        </AstraParagraph>
    </div>
)

type Props = {
    onClose: () => void
}

export const ApplyPreviewDialog = ({ onClose }: Props) => {
    const selectedDate = useStore(state => state.appFilters.selectedDate)
    const firstDayOfMonth = selectedDate.startOf('month')
    const lastDayOfMonth = selectedDate.endOf('month')

    const practitioners = useActivePractitioners()
    const recurringAssignments = useActiveRecurringAssignments()
    const deselectedRecurringAssignmentUuids = useStore(state => state.surgeonScheduler.deselectedRecurringAssignmentUuids)
    const allRecurringAssignmentUuids = recurringAssignments.map(recurring => recurring.uuid)
    const selectedRecurringAssignmentUuids = allRecurringAssignmentUuids.filter(uuid => !deselectedRecurringAssignmentUuids.includes(uuid))

    const request = {
        preview_practitioner_uuids: practitioners.map(practitioner => practitioner.uuid),
        recurring_assignment_uuids: selectedRecurringAssignmentUuids,
        start_date: getOnlyDate(firstDayOfMonth),
        end_date: getOnlyDate(lastDayOfMonth),
    }
    const { data, isLoading } = useApplyRecurringAssignmentsQuery(request)
    const { mutate: apply, isPending, isError } = useApplyRecurringAssignmentsMutation()
    const previewData = useApplyPreviewData(data, request, practitioners)

    return (
        <div className="flex h-[85vh] w-[95vw] items-start justify-center p-8">
            <div className="grid h-full w-full grid-cols-12 justify-end gap-4">
                {isLoading ? (
                    <div className="col-span-8 flex h-full items-center justify-center">
                        <Loader />
                    </div>
                ) : (
                    <div className="col-span-8 h-full overflow-auto">
                        <PractitionersPreview previewData={previewData} />
                    </div>
                )}
                <div className="col-span-4 flex h-full flex-col gap-2">
                    <RecurringAssignmentToggleList onApply={() => apply(request, { onSuccess: onClose })} disabledApplyButton={isPending} />
                    {isError && <p role="alert">Kunne ikke fylle inn planen. Prøv igjen.</p>}
                </div>
            </div>
        </div>
    )
}
